import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ProjectInfo from "./ProjectInfo";
import "./Sidebar.css";
import DocManagementLayout from "./DocManagementLayout";
import Icon12 from "../img/7178d169a7be088cdc1b5e359f57869b33e4aa6356998dd541a860989097bb95.svg";
import projectIconWhite from "../img/540c6ef86ee7b47ca5a7ffc2f89e05a3b1bea144157f7be115142ac4f72d107a.svg";
import projectIconBlack from "../img/ca5a7ffc2f89e05a3b1bea144157f7be115142ac4f72d107a.svg";
import manageContactsBlack from "../img/4fc2b890fdab97816c49ad8e37fc297bda941f891813707e7dba20bf5456a9ec.svg";
import manageContactsWhite from "../img/manageContactsWhite.svg";

function Sidebar({ isCollapsed,projectData  }) {
  const location = useLocation();
  const isContactsPage = location.pathname.includes('/contacts');
  const isManageContactsPage = location.pathname === '/contacts/manage';
  const [activeContactTab, setActiveContactTab] = useState(null);

  const [isProjectInfoExpanded, setIsProjectInfoExpanded] = useState(false);
  const [isDocManagementExpanded, setIsDocManagementExpanded] = useState(false);
  const [isLinksExpanded, setIsLinksExpanded] = useState(false);
  const [isContactsExpanded, setIsContactsExpanded] = useState(false);

  // Get selected department from localStorage or use default
  const [selectedDepartment, setSelectedDepartment] = useState(() => 
    localStorage.getItem('selectedDepartment') || 'Engineered Fill'
  );
  
  const [isProjectSelected, setIsProjectSelected] = useState(() =>
    localStorage.getItem('isProjectSelected') === 'true'
  );

  useEffect(() => {
    const handleDepartmentChange = (event) => {
      setSelectedDepartment(event.detail);
      setIsProjectSelected(true);
    };

    window.addEventListener('departmentChanged', handleDepartmentChange);
    return () => {
      window.removeEventListener('departmentChanged', handleDepartmentChange);
    };
  }, []);

  const menuItems = [
    {
      id: 'project-list',
      label: 'Project List',
      icon: location.pathname === '/' ? (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4C4 3.44772 4.44772 3 5 3H15C15.5523 3 16 3.44772 16 4V16C16 16.5523 15.5523 17 15 17H5C4.44772 17 4 16.5523 4 16V4Z" 
            stroke={location.pathname === '/' ? "#DC2626" : "#374151"} 
            strokeWidth="2"
          />
          <circle cx="8" cy="8" r="1" 
            fill={location.pathname === '/' ? "#DC2626" : "#374151"}
          />
          <path d="M10 8H13" 
            stroke={location.pathname === '/' ? "#DC2626" : "#374151"} 
            strokeWidth="2" 
            strokeLinecap="round"
          />
          <circle cx="8" cy="12" r="1" 
            fill={location.pathname === '/' ? "#DC2626" : "#374151"}
          />
          <path d="M10 12H13" 
            stroke={location.pathname === '/' ? "#DC2626" : "#374151"} 
            strokeWidth="2" 
            strokeLinecap="round"
          />
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4C4 3.44772 4.44772 3 5 3H15C15.5523 3 16 3.44772 16 4V16C16 16.5523 15.5523 17 15 17H5C4.44772 17 4 16.5523 4 16V4Z" 
            stroke="#374151" 
            strokeWidth="2"
          />
          <circle cx="8" cy="8" r="1" 
            fill="#374151"
          />
          <path d="M10 8H13" 
            stroke="#374151" 
            strokeWidth="2" 
            strokeLinecap="round"
          />
          <circle cx="8" cy="12" r="1" 
            fill="#374151"
          />
          <path d="M10 12H13" 
            stroke="#374151" 
            strokeWidth="2" 
            strokeLinecap="round"
          />
        </svg>
      ),
      path: '/',
      active: location.pathname === '/'
    },
    {
      id: 'dashboard',
      label: isProjectSelected ? `Dashboard - ${selectedDepartment}` : "Dashboard",
      icon: location.pathname === '/dashboard' ? (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" 
            stroke="#DC2626" 
            strokeWidth="2"
          />
          <path d="M10 10L14 6" 
            stroke="#DC2626" 
            strokeWidth="2" 
            strokeLinecap="round"
          />
          <path d="M9.5 10C9.5 10.2761 9.72386 10.5 10 10.5C10.2761 10.5 10.5 10.2761 10.5 10C10.5 9.72386 10.2761 9.5 10 9.5C9.72386 9.5 9.5 9.72386 9.5 10Z" 
            stroke="#DC2626" 
            strokeWidth="2"
          />
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" 
            stroke="#374151" 
            strokeWidth="2"
          />
          <path d="M10 10L14 6" 
            stroke="#374151" 
            strokeWidth="2" 
            strokeLinecap="round"
          />
          <path d="M9.5 10C9.5 10.2761 9.72386 10.5 10 10.5C10.2761 10.5 10.5 10.2761 10.5 10C10.5 9.72386 10.2761 9.5 10 9.5C9.72386 9.5 9.5 9.72386 9.5 10Z" 
            stroke="#374151" 
            strokeWidth="2"
          />
        </svg>
      ),
      path: '/dashboard',
      active: location.pathname === '/dashboard'
    }
  ];

  const links = [
    "Field Drawings",
    "Submittals",
    "Final Est & Proposal",
    "Production Report",
    "Acumatica",
    "Salesforce",
    "Online Takeoff",
    "Reports",
    "Projects List",
  ];

  const contactTabData = [
    {
      id: "project",
      label: "Project Contacts",
      icon: (tab) => {
        const isSelected = !isManageContactsPage && activeContactTab === "project";
        return isSelected ? projectIconWhite : projectIconBlack;
      },
      path: "/contacts"
    },
    {
      id: "manage",
      label: "Manage Contacts",
      icon: (tab) => {
        const isSelected = isManageContactsPage && activeContactTab === "manage";
        return isSelected ? manageContactsWhite : manageContactsBlack;
      },
      path: "/contacts/manage"
    }
  ];

  const ProjectInfoSection = () => {
    return (
      <>
        <div className={`menu-item-wrapper ${isProjectInfoExpanded ? 'active' : ''}`}>
          <div className={`indicator ${isProjectInfoExpanded ? 'active' : ''}`} />
          <div 
            className="menu-item"
            onClick={() => setIsProjectInfoExpanded(!isProjectInfoExpanded)}
            style={{ cursor: 'pointer' }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path 
                d="M6 2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" 
                stroke={isProjectInfoExpanded ? "#DC2626" : "#374151"} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
              <path 
                d="M8 6h4M8 10h4M8 14h2" 
                stroke={isProjectInfoExpanded ? "#DC2626" : "#374151"} 
                strokeWidth="2" 
                strokeLinecap="round"
              />
            </svg>
            <span className="menu-text">Project Info</span>
            <svg 
              className={`dropdown-icon ${isProjectInfoExpanded ? 'rotate-180' : ''}`}
              width="20" 
              height="20" 
              viewBox="0 0 20 20" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M5 7.5L10 12.5L15 7.5" 
                stroke={isProjectInfoExpanded ? "#DC2626" : "#374151"} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        {isProjectInfoExpanded && (
          <div className="project-info-content">
            <ProjectInfo />
          </div>
        )}
      </>
    );
  };

  const ContactsSection = () => {
    return (
      <>
        <div className={`menu-item-wrapper ${isContactsExpanded ? 'active' : ''}`}>
          <div className={`indicator ${isContactsExpanded ? 'active' : ''}`} />
          <div 
            className="menu-item"
            onClick={() => setIsContactsExpanded(!isContactsExpanded)}
            style={{ cursor: 'pointer' }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 17V15C16 13.9391 15.5786 12.9217 14.8284 12.1716C14.0783 11.4214 13.0609 11 12 11H8C6.93913 11 5.92172 11.4214 5.17157 12.1716C4.42143 12.9217 4 13.9391 4 15V17" stroke={isContactsExpanded ? "#DC2626" : "#374151"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 7C11.6569 7 13 5.65685 13 4C13 2.34315 11.6569 1 10 1C8.34315 1 7 2.34315 7 4C7 5.65685 8.34315 7 10 7Z" stroke={isContactsExpanded ? "#DC2626" : "#374151"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="menu-text">Contacts</span>
            <svg 
              className={`dropdown-icon ${isContactsExpanded ? 'rotate-180' : ''}`}
              width="20" 
              height="20" 
              viewBox="0 0 20 20" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M5 7.5L10 12.5L15 7.5" 
                stroke={isContactsExpanded ? "#DC2626" : "#374151"} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        {isContactsExpanded && (
          <div className="contacts-content">
            {contactTabData.map((tab) => (
              <Link 
                key={tab.id}
                to={tab.path}
                className={`contact-tab-item ${
                  (tab.id === "project" && !isManageContactsPage && location.pathname.includes('/contacts')) ||
                  (tab.id === "manage" && isManageContactsPage)
                    ? 'active'
                    : ''
                }`}
                onClick={() => setActiveContactTab(tab.id)}
              >
                <div className="indicator"></div>
                <div className="tab-content">
                  {tab.label}
                </div>
              </Link>
            ))}
          </div>
        )}
      </>
    );
  };

  const DocManagementSection = () => {
    return (
      <>
        <div className={`menu-item-wrapper ${isDocManagementExpanded ? 'active' : ''}`}>
          <div className={`indicator ${isDocManagementExpanded ? 'active' : ''}`} />
          <div 
            className="menu-item"
            onClick={() => setIsDocManagementExpanded(!isDocManagementExpanded)}
            style={{ cursor: 'pointer' }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 6C2 4.89543 2.89543 4 4 4H7L9 6H16C17.1046 6 18 6.89543 18 8V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6Z" 
                stroke={isDocManagementExpanded ? "#DC2626" : "#374151"} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
            <span className="menu-text">Doc Management - RD</span>
            <svg 
              className={`dropdown-icon ${isDocManagementExpanded ? 'rotate-180' : ''}`}
              width="20" 
              height="20" 
              viewBox="0 0 20 20" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M5 7.5L10 12.5L15 7.5" 
                stroke={isDocManagementExpanded ? "#DC2626" : "#374151"} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        {isDocManagementExpanded && <DocManagementLayout projectData={projectData}/>}
      </>
    );
  };

  const LinksSection = () => {
    return (
      <>
        <div className={`menu-item-wrapper ${isLinksExpanded ? 'active' : ''}`}>
          <div className={`indicator ${isLinksExpanded ? 'active' : ''}`} />
          <div 
            className="menu-item"
            onClick={() => setIsLinksExpanded(!isLinksExpanded)}
            style={{ cursor: 'pointer' }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" 
                stroke={isLinksExpanded ? "#DC2626" : "#374151"} 
                strokeWidth="2"
              />
              <path d="M2 10H18M10 2C12.5013 4.73835 13.9228 7.29203 14 10C13.9228 12.708 12.5013 15.2616 10 18C7.49872 15.2616 6.07725 12.708 6 10C6.07725 7.29203 7.49872 4.73835 10 2Z" 
                stroke={isLinksExpanded ? "#DC2626" : "#374151"} 
                strokeWidth="2"
              />
            </svg>
            <span className="menu-text">Links</span>
            <svg 
              className={`dropdown-icon ${isLinksExpanded ? 'rotate-180' : ''}`}
              width="20" 
              height="20" 
              viewBox="0 0 20 20" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M5 7.5L10 12.5L15 7.5" 
                stroke={isLinksExpanded ? "#DC2626" : "#374151"} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        {isLinksExpanded && (
          <div className="submenu-content">
            <ul className="links-list">
              {links.map((link, index) => (
                <li key={index} className="link-item">
                  <a href="#" className="link-text">{link}</a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    );
  };

  if (isCollapsed) {
    return null;
  }

  return (
    <aside className="dashboard-sidebar">
      <nav className="sidebar-nav">
        <div className="flex flex-col h-full py-4">
          {menuItems.map((item) => (
            <div key={item.id} className={`menu-item-wrapper ${item.active ? 'active' : ''}`}>
              <div className={`indicator ${item.active ? 'active' : ''}`} />
              <Link
                to={item.path}
                className="menu-item"
              >
                {typeof item.icon === 'string' ? (
                  <img src={item.icon} alt="" className="menu-icon" />
                ) : (
                  item.icon
                )}
                <span className="menu-text">{item.label}</span>
              </Link>
            </div>
          ))}
          
          <ProjectInfoSection />
          <ContactsSection />
          <DocManagementSection />
          <LinksSection />
        </div>
      </nav>
    </aside>
  );
}

export default Sidebar;